import { axios } from '@slg/web-customer-shared';
import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import store from '@/store';
import { strapiInstance } from '@slg/web-customer-shared/src/services/StrapiService';
import i18n from '@/plugins/i18n';

const whiteList = [
  'maps.googleapis.com',
  'apiv3.geoportail.lu',
];

// eslint-disable-next-line no-undef
const clusterHost = config.VUE_APP_CLUSTER_HOST || process.env.VUE_APP_CLUSTER_HOST;

export default function setup(): void {
  strapiInstance.interceptors.request.use(
    (axiosConfig: InternalAxiosRequestConfig) => {
      axiosConfig.params = {
        ...(axiosConfig.params || {}),
        locale: i18n.locale,
      };
      // eslint-disable-next-line no-undef
      const strapiUrl = config.VUE_APP_STRAPI_URL || process.env.VUE_APP_STRAPI_URL || '';
      // eslint-disable-next-line no-undef
      const strapiClusterUrl = config.VUE_APP_STRAPI_CLUSTER_URL || process.env.VUE_APP_STRAPI_CLUSTER_URL;

      const { hostname } = new URL(window.location.href);

      axiosConfig.baseURL = hostname === clusterHost ? strapiClusterUrl : strapiUrl;
      return axiosConfig;
    },
  );

  axios.interceptors.request.use(
    (axiosConfig: InternalAxiosRequestConfig) => {
      if (whiteList.some((item) => (axiosConfig.url || '').includes(item))) {
        return axiosConfig;
      }
      // eslint-disable-next-line no-undef
      const baseUrl = config.VUE_APP_BACKEND_URL || process.env.VUE_APP_BACKEND_URL;
      // eslint-disable-next-line no-undef
      const tenantName = config.VUE_APP_TENANT_NAME || process.env.VUE_APP_TENANT_NAME;
      // eslint-disable-next-line no-undef
      const serviceName = config.VUE_APP_SERVICE_NAME || process.env.VUE_APP_SERVICE_NAME;
      // eslint-disable-next-line no-undef
      const backendClusterHost = config.VUE_APP_BACKEND_CLUSTER_URL || process.env.VUE_APP_BACKEND_CLUSTER_URL;

      axiosConfig.url = (axiosConfig.url || '')
        .replace('{TENANT_NAME}', tenantName || '')
        .replace('{SERVICE_NAME}', serviceName || '');

      const { hostname } = new URL(window.location.href);

      axiosConfig.baseURL = hostname === clusterHost ? backendClusterHost : baseUrl;
      const authToken = localStorage.getItem('authToken');
      if (authToken) {
        axiosConfig.headers.set('authorization', `Bearer ${authToken}`);
      }
      return axiosConfig;
    },
  );

  axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    ({ response }: { response?: AxiosResponse }) => {
      const { data, status } = response || {};
      const { errorCode, message, errorDetails } = data || {};
      const dataToThrow = {
        message,
        errorCode,
        errorDetails,
        status,
      };
      if (status === 401) {
        store.commit('common/changeSessionExpiredDialogOpenState', true);
      }
      return Promise.reject(dataToThrow);
    },
  );
}
